
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges , OnInit} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ClassificationType } from "../../models/classification.model";
import { ClassificationService } from "../../services/classification/classification.service";

@Component({
  selector: 'app-classification-types-form',
  templateUrl: './classification-types-form.component.html',
  styles: ['.label.required:after, label.required:after {top: 0}']
})
export class ClassificationTypesFormComponent implements OnChanges, OnInit {


  @Output() onAddElement:EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: ClassificationType;

  addEditFormTypes: FormGroup;
  fields: any;
  invalidSubmit: boolean;

  constructor(private fb: FormBuilder, private svcClassification: ClassificationService) {}

  ngOnInit(): void {
    this.svcClassification.getFieldsType().subscribe(res => this.fields = res);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.addEditFormTypes = this.fb.group({
      'name': new FormControl('')
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditFormTypes.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    var newData = Object.assign({}, this.editingElement, this.addEditFormTypes.value);
    this.onAddElement.emit(newData);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/classification-types/classification-types-form.component.ts